module.exports = __webpack_public_path__ + "static/media/misty-win.31f54a63.png";